const getCookie = (cname) => {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie.replace(/\+/g, '%20'))
  const cookies = decodedCookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    // Trim space from beginning
    const cookie = cookies[i].trim()

    if (cookie.includes(name, 0)) {
      return cookie.substring(name.length, cookie.length)
    }
  }

  return ''
}

export default getCookie
